import { useState, useCallback } from 'react';
// import { v4 as uuid } from 'uuid';

import { useAppDispatch } from 'app/hooks';

import { setTemporaryBaseline } from 'features/snapshots/snapshotsSlice';

import { TraceHistoryFilters, TraceHistoryMap } from '../types';
// import useBaselineTrace from 'features/lineChart/hooks/useBaselineTrace';
// import { useSnapshot } from 'features/snapshots/api/getSnapshot';

interface Props {
  traceHistory: TraceHistoryMap | null;
  activeHistory: TraceHistoryFilters;
  currentHoveredSnapshotKey: number;
  globalTraceIndex: number;
  activeSettingsKey: number;
  setDeleteDialogOpen: (...args: any) => void;
}

const useTraceHistoryToolbar = ({
  traceHistory,
  activeHistory,
  currentHoveredSnapshotKey,
  globalTraceIndex,
  activeSettingsKey,
  setDeleteDialogOpen,
}: Props) => {
  const dispatch = useAppDispatch();

  const [drawingType, setDrawingType] = useState<
    'mask' | 'monitor' | 'threshold' | null
  >(null);
  const [drawLine, setDrawLine] = useState(false);
  const [redrawId, setRedrawId] = useState<number>(-1);
  const [clearDetector, setClearDetector] = useState<
    'Monitors' | 'Masks' | 'Thresholds' | ''
  >('');
  const [inDrawingMode, setInDrawingMode] = useState(false);
  const [currentDialog, setCurrentDialog] = useState('none');

  const selectedMonitor = undefined;

  const selectedMask = undefined;

  const selectedThreshold = undefined;

  // const currentlyActiveTraceHistory = traceHistory
  //   ? traceHistory[currentHoveredSnapshotKey][globalTraceIndex]
  //   : undefined;
  // const { data: currentlyActiveSnapshot } = useSnapshot({
  //   snapshotId: currentlyActiveTraceHistory?.snapshot_id
  //     ? currentlyActiveTraceHistory.snapshot_id
  //     : -1,
  // });

  // const baseLine = useBaselineTrace(
  //   currentlyActiveSnapshot?.baseline_trace,
  //   currentlyActiveSnapshot?.baseline_enabled,
  //   false
  // );

  const openMonitorDialog = useCallback(() => setCurrentDialog('monitor'), []);
  const openMaskDialog = useCallback(
    () => setCurrentDialog('spectral-mask'),
    []
  );
  const openThresholdDialog = useCallback(
    () => setCurrentDialog('threshold'),
    []
  );
  const closeDialogs = useCallback(() => {
    setCurrentDialog('none');
  }, []);

  const redrawDetector = (
    startXIndex: number,
    endXIndex: number,
    startYValue: number,
    endYValue: number
  ) => {
    if (drawingType === 'monitor') {
      if (!selectedMonitor) return;

      // const redrawnMonitor = {
      //   id: selectedMonitor?.id,
      //   snapshot_id: selectedMonitor?.snapshot_id,
      //   begin: startXIndex,
      //   end: endXIndex,
      //   upperbound:
      //     (Math.round((startYValue + Number.EPSILON) * 100) / 100) * 1000,
      //   lowerbound:
      //     (Math.round((endYValue + Number.EPSILON) * 100) / 100) * 1000,
      // };

      //dispatch(updateTemporaryMonitor(redrawnMonitor));
      setRedrawId(-1);
    } else if (drawingType === 'threshold') {
      if (!selectedThreshold) return;

      // const redrawnThreshold = {
      //   id: selectedThreshold.id,
      //   snapshot_id: selectedThreshold.snapshot_id,
      //   begin: startXIndex,
      //   end: endXIndex,
      //   bound: (Math.round((endYValue + Number.EPSILON) * 100) / 100) * 1000,
      // };

      // dispatch(updateTemporaryThreshold(redrawnThreshold));
      setRedrawId(-1);
    } else if (drawingType === 'mask') {
      if (!selectedMask) return;

      // const startYDifference = Math.abs(
      //   Math.round(
      //     ((startYValue + Number.EPSILON) * 100) / 100 - baseLine[startXIndex]
      //   ) * 1000
      // );
      // const endYDifference = Math.abs(
      //   Math.round(
      //     ((endYValue + Number.EPSILON) * 100) / 100 - baseLine[endXIndex]
      //   ) * 1000
      // );
      // const upperbound =
      //   startYValue > endYValue ? startYDifference : endYDifference;
      // const lowerbound =
      //   endYValue <= startYValue ? endYDifference : startYDifference;
      // const redrawnMask = {
      //   ...selectedMask,
      //   id: selectedMask.id,
      //   snapshot_id: selectedMask.snapshot_id,
      //   begin: startXIndex,
      //   end: endXIndex,
      //   upperbound,
      //   lowerbound,
      // };

      // dispatch(updateTemporaryMask(redrawnMask));
      setRedrawId(-1);
    }
  };

  const handleDrawingCompleted = (
    startXIndex: number,
    endXIndex: number,
    startYValue: number,
    endYValue: number
  ) => {
    if (startXIndex >= endXIndex) return;
    if (!traceHistory) return;

    const hoveredSnapshot =
      traceHistory[currentHoveredSnapshotKey][globalTraceIndex];

    if (!hoveredSnapshot) return;

    if (redrawId !== -1) {
      redrawDetector(startXIndex, endXIndex, startYValue, endYValue);
      return;
    }

    if (drawingType === 'monitor') {
      // const monitor = {
      //   id: uuid(),
      //   snapshot_id: hoveredSnapshot.snapshot_id,
      //   name: 'New Monitor',
      //   begin: startXIndex,
      //   end: endXIndex,
      //   upperbound:
      //     (Math.round((startYValue + Number.EPSILON) * 100) / 100) * 1000,
      //   lowerbound:
      //     (Math.round((endYValue + Number.EPSILON) * 100) / 100) * 1000,
      // };
      //dispatch(createTemporaryMonitor(monitor));
    } else if (drawingType === 'mask') {
      // const startYDifference = Math.abs(
      //   Math.round(
      //     ((startYValue + Number.EPSILON) * 100) / 100 - baseLine[startXIndex]
      //   ) * 1000
      // );
      // const endYDifference = Math.abs(
      //   Math.round(
      //     ((endYValue + Number.EPSILON) * 100) / 100 - baseLine[endXIndex]
      //   ) * 1000
      // );
      // const upperbound =
      //   startYValue > endYValue ? startYDifference : endYDifference;
      // const lowerbound =
      //   endYValue <= startYValue ? endYDifference : startYDifference;
      // const mask = {
      //   id: uuid(),
      //   snapshot_id: hoveredSnapshot.snapshot_id,
      //   name: 'New Mask',
      //   begin: startXIndex,
      //   end: endXIndex,
      //   upperbound,
      //   lowerbound,
      // };
      // dispatch(createTemporaryMask(mask));
    } else if (drawingType === 'threshold') {
      // const threshold = {
      //   id: uuid(),
      //   snapshot_id: hoveredSnapshot.snapshot_id,
      //   name: 'New Threshold',
      //   begin: startXIndex,
      //   end: endXIndex,
      //   bound: (Math.round((startYValue + Number.EPSILON) * 100) / 100) * 1000,
      // };
      //dispatch(createTemporaryThreshold(threshold));
    }

    setInDrawingMode(false);
    setDrawingType(null);
  };

  const handleBaselineClicked = (baselineEnabled: boolean | undefined) => {
    if (!traceHistory) return;

    const lastHistoryItem =
      traceHistory[activeSettingsKey][
        traceHistory[activeSettingsKey].length - 1
      ];

    const baselineTrace = !baselineEnabled ? lastHistoryItem.trace : null;

    dispatch(
      setTemporaryBaseline({
        snapshotId: lastHistoryItem.snapshot_id,
        baselineTrace: baselineTrace,
        baselineEnabled: !baselineEnabled,
      })
    );
  };

  const handleCreateMonitorClicked = () => {
    setDrawLine(false);
    setInDrawingMode(true);
    setDrawingType('monitor');
  };

  const handleCreateMaskClicked = () => {
    setDrawLine(false);
    setInDrawingMode(true);
    setDrawingType('mask');
  };

  const handleCreateThresholdClicked = () => {
    setInDrawingMode(true);
    setDrawLine(true);
    setDrawingType('threshold');
  };

  const handleRedrawMonitor = (monitorId: number) => {
    setDrawLine(false);
    setRedrawId(monitorId);
    setDrawingType('monitor');
    setInDrawingMode(true);
    setCurrentDialog('');
  };

  const handleRedrawMask = (maskId: number) => {
    setRedrawId(maskId);
    setDrawLine(false);
    setDrawingType('mask');
    setInDrawingMode(true);
    setCurrentDialog('');
  };

  const handleRedrawThreshold = (thresholdId: number) => {
    setDrawLine(true);
    setRedrawId(thresholdId);
    setDrawingType('threshold');
    setInDrawingMode(true);
    setCurrentDialog('');
  };

  const handleClearMonitorsClicked = () => {
    // dispatch(
    //   clearMonitorsTemporarilyBySnapshotId({
    //     snapshotId: activeHistory.snapshotId,
    //   })
    // );
  };

  const handleClearMasksClicked = () => {
    // dispatch(
    //   clearMasksTemporarilyBySnapshotId({
    //     snapshotId: activeHistory.snapshotId,
    //   })
    // );
  };

  const handleClearThresholdsClicked = () => {
    // dispatch(
    //   clearThresholdsTemporarilyBySnapshotId({
    //     snapshotId: activeHistory.snapshotId,
    //   })
    // );
  };

  const handleClearClicked = (
    detector: 'Monitors' | 'Masks' | 'Thresholds'
  ) => {
    setClearDetector(detector);
    setDeleteDialogOpen(true);
  };

  const clearAlarmTriggers = () => {
    switch (clearDetector) {
      case 'Monitors':
        handleClearMonitorsClicked();
        break;
      case 'Masks':
        handleClearMasksClicked();
        break;
      case 'Thresholds':
        handleClearThresholdsClicked();
        break;
      default:
        break;
    }
  };

  return {
    inDrawingMode,
    currentDialog,
    clearDetector,
    openMonitorDialog,
    openMaskDialog,
    openThresholdDialog,
    closeDialogs,
    handleDrawingCompleted,
    handleBaselineClicked,
    handleCreateMonitorClicked,
    handleCreateMaskClicked,
    handleCreateThresholdClicked,
    handleRedrawMonitor,
    handleRedrawMask,
    handleRedrawThreshold,
    handleClearClicked,
    clearAlarmTriggers,
    drawLine,
  } as const;
};

export default useTraceHistoryToolbar;
